// extracted by mini-css-extract-plugin
export default {"modal":"OS-z","error":"PS-z","disabled":"QS-z","fields":"RS-z","errorMsg":"SS-z","footer":"TS-z","formContentWrapper":"US-z","productImage":"VS-z","overlay":"WS-z"};